import React, { useRef, useState, useEffect } from "react";
import helpers from "helpers/base";
import Modal from "./Modal";
import GoogleAuthButton from "./GoogleAuthButton";
import AppBanner from "./AppBanner";

const clearErrorMessage = () => {
  AppBanner.clear();
};

function SignUpWithModal(props) {
  const { googleOAuthEnabled } = props;
  const modal = useRef(null);
  const [provider, _setProvider] = useState(null);
  const [gdpr, _setGdpr] = useState(null);
  const [subscriptionType, _setSubscriptionType] = useState(null);

  // when using state in functional components, only the initial state will be
  // available at the time event listeners are created, so we create refs and
  // functions that update them (perhaps messier than just using a react class component)
  const providerRef = useRef(provider);
  const setProvider = (data) => {
    providerRef.current = data;
    _setProvider(data);
  };

  const subscriptionTypeRef = useRef(subscriptionType);
  const setSubscriptionType = (data) => {
    subscriptionTypeRef.current = data;
    _setSubscriptionType(data);
  };

  const gdprRef = useRef(gdpr);
  const setGdpr = (data) => {
    gdprRef.current = data;
    _setGdpr(data);
  };

  useEffect(() => {
    modal.current.$modal.on("show.bs.modal", (e) => {
      clearErrorMessage();
      setSubscriptionType(e.relatedTarget.dataset.subscriptionType);
    });
  }, []);

  const redirect = (redirectLocation = null) => {
    if (redirectLocation) {
      window.location.href = redirectLocation;
    } else {
      const queryParams = {
        ...helpers.getQueryParams(),
        gdpr: gdprRef.current || false,
        provider: providerRef.current,
        subscription: subscriptionTypeRef.current
      };
      const qpString = helpers.object
        .map(queryParams, (key, value) => `${key}=${value}`)
        .join("&");
      const path = `/sign-up?${qpString}`;
      window.location.href = path;
    }
  };

  const handleSkipFormAndCreateAccount = () => {
    // User is outside of the GDPR, we can go straight to payment on the
    // registration page
    setGdpr(false);
    signUpWithGoogle();
  };

  const signUpWithGoogle = () => {
    setProvider("google");
    if (gdprRef.current !== false) {
      setGdpr(true);
    }
    clearErrorMessage();
    redirect();
  };

  const signUpWithEmail = (_event) => {
    setProvider("email");
    redirect();
  };

  return (
    <Modal
      ref={modal}
      id="sign-up-with-modal"
      title="How would you like to sign&nbsp;up?"
      showOnMount={false}
      footer={false}
      closeIcon
    >
      <div className="sign-up-with-modal__actions">
        <AppBanner />
        {googleOAuthEnabled && (
          <GoogleAuthButton
            flow="sign-up"
            onSkipFormAndCreateAccount={handleSkipFormAndCreateAccount}
            onRegistrationInProgress={signUpWithGoogle}
            text="signup_with"
            subscription={subscriptionTypeRef.current}
          />
        )}
        <button
          type="submit"
          data-provider="email"
          className="btn btn-default btn-md"
          onClick={signUpWithEmail}
        >
          Sign up with Email
        </button>
      </div>
    </Modal>
  );
}

export default SignUpWithModal;
